module.exports = __webpack_public_path__ + "img/pxn_pixversetkns.fadce40.png";